import { Framework } from '@vfpf/framework';
import { ModalProcessDeps } from './deps';

export type ModalMethods = {
  showModal: <I, O>(
    innerModal: React.FC,
    onSubmit?: (outputData?: O) => void,
    backdrop?: 'static'
  ) => void;
  hideModal: () => void;
};

export const showModal = <I, O>(
  innerModal: React.FC,
  deps: ModalProcessDeps,
  onSubmit?: (outputData?: O) => void,
  backdrop?: 'static'
) => {
  deps.dispatch(state => ({
    component: innerModal,
    show: true,
    onSubmit: (outputData?: O) => {
      if (onSubmit) onSubmit(outputData);
    },
    backdrop: backdrop,
  }));
};

export const hideModal = (deps: ModalProcessDeps) => deps.dispatch(state => ({ ...state, show: false }));

export const modalProcessCreator: Framework.ProcessCreator<ModalMethods> = (deps: ModalProcessDeps) => ({
  showModal: (innerModal, onSubmit, backdrop) =>
    showModal(innerModal, deps, onSubmit, backdrop),
  hideModal: () => hideModal(deps),
});
